/** @jsx jsx */
import { useContext } from 'react';
import { Box, jsx } from 'theme-ui';
import Sticky from 'react-stickynode';
import LoadingBar from 'react-top-loading-bar';
import Topbar from './topbar/topbar';
import Navbar from './navbar/navbar';
import useWindowSize from '../../hooks/useWindowSize';
import styles from './header.style';
import { CartContext } from '../../provider/cart-provider';

const Header: React.FC<{}> = () => {
	const { width } = useWindowSize();
	const {
		store: { updating },
	} = useContext(CartContext);
	return (
		<Box as="header" sx={styles.header}>
			{updating && <LoadingBar progress={100} height={3} color="#292929" />}
			{width > 991 ? (
				<Topbar />
			) : (
				<Sticky activeClass="active" innerZ={9}>
					<Topbar />
				</Sticky>
			)}
			{width > 991 ? (
				<Sticky activeClass="active" innerZ={9}>
					<Navbar />
				</Sticky>
			) : null}
		</Box>
	);
};

export default Header;
